export default __webpack_public_path__ + "static/media/map-pin.58f14804.svg";